import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import { useState } from "react";
import { snack } from "components/Snack/Snack";
import { toFormData } from "helpers/formUtils";
import productsService from "services/admin/productsService";
import categoriesService from "services/admin/categoriesService";
import vendorsService from "services/admin/vendorsService";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { Button, FormControl, InputLabel, MenuItem, Select, Tab, Tabs, TextField } from "@mui/material";
import TextEditor from "components/TextEditor/TextEditor";
import { SpecificationForm } from "components/SpecificationForm/SpecificationForm";
import { FileInput } from "components/FileInput/FileInput";
import warehousesService from "services/admin/warehousesService";

const ProductForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { product, categories, vendors, salePoints },
}) => {
  const [tab, setTab] = useState('general');
  const methods = useForm({
    defaultValues: {
      name: product?.name,
      photo: product?.photo,
      // Артикул продавца
      merchantSku: product?.merchantSku,
      // Артикул производителя
      sku: product?.sku,
      description: product?.description,
      vendorID: product?.vendorID,
      categoryID: product?.categoryID,
      specifications: product?.specifications || {},
    }
  })


  const onSubmit = async (formValues) => {
    console.log('formValues: ', formValues)
    try {
      const formData = toFormData(formValues);

      if (product) {
        await productsService.put(id, formData)
        snack("Товар обновлен успешно!");
      } else {
        await productsService.post(formData)
        snack("Товар создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  // Построение характеристик из категории 
  const buildSpecifications = () => {
    const selectedCategoryID = methods.getValues("categoryID")
    if (!selectedCategoryID) {
      return null
    }

    const specifications = categories.data.find(c => c.id === selectedCategoryID)?.specifications || []

    console.log("specifications: ", specifications)

    return specifications.map((specification, index) => {
      return <SpecificationForm specification={specification} index={index} />
    })
  }

  return (
    <CrudPage title={product ? 'Редактирование товара' : 'Создание товара'}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="app-form">
          <div id="product-tabs" className="m-b-16" style={{ display: 'flex', gap: '10px' }}>
            <Tabs value={tab} onChange={(event, newValue) => {
              setTab(newValue);
            }}>
              <Tab label="Основная информация" value="general" />
              <Tab label="Характеристики" value="specifications" />
              {!id ? <Tab label="Цена и остатки" value="prices-and-stocks" /> : null}
            </Tabs>
          </div>
          <section id="general-form" className="app-form" style={{ display: tab === 'general' ? 'block' : 'none' }}>
            <Controller
              control={methods.control}
              label="Категория"
              name="categoryID"
              render={({ field }) => {
                return <FormControl fullWidth>
                  <InputLabel>Категория</InputLabel>
                  <Select {...field} label="Категория" disabled={id ? true : false}>
                    {categories.data.map((c) => {
                      return <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              }}
            />
            <TextField
              fullWidth
              label="Название товара"
              name="name"
              {...methods.register('name')}
            />
            <Controller
              control={methods.control}
              name="photo"
              render={({ field }) => {
                return <FileInput key="photo" label="Основное фото товара" value={field.value} onChange={field.onChange} />
              }}
            />
            <TextField
              fullWidth
              label="Артикул"
              name="merchantSku"
              type="text"
              {...methods.register('merchantSku', {
                disabled: id ? true : false
              })}
            />
            <Controller
              control={methods.control}
              name="vendorID"
              render={({ field }) => {
                return <FormControl fullWidth>
                  <InputLabel>Бренд</InputLabel>
                  <Select {...field} label="Бренд" disabled={id ? true : false}>
                    {vendors.map((v) => {
                      return <MenuItem key={v.id} value={v.id}>{v.name}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              }}
            />
            <Controller
              control={methods.control}
              name="description"
              render={({ field }) => {
                return <TextEditor
                  value={field.value}
                  onChange={(value) => {
                    field.onChange(value)
                  }}
                  {...field}
                ></TextEditor>
              }}
            />
            <TextField
              fullWidth 
              label="Артикул производителя"
              name="sku"
              helperText="Артикул указывается на упаковке, бирке, этикетке или в накладной. Обычно состоит из цифр, но может содержать буквы и другие символы."
              {...methods.register('sku', { required: true })}
            />
            <Button variant="contained" type="button" onClick={() => {
              setTab('specifications');
            }}>Добавить характеристики</Button>

          </section>
          <section id="product-specifications" style={{ display: tab === 'specifications' ? 'block' : 'none' }}>
            {buildSpecifications()}
            {id ? <Button variant="contained" type="submit">Отправить на модерацию</Button> : <Button variant="contained" type="button" onClick={() => {
              setTab('prices-and-stocks');
            }}>Добавить цену и остатки</Button>}
          </section>
          {id ? null : <section id="prices-and-stocks" style={{ display: tab === 'prices-and-stocks' ? 'block' : 'none' }}>
            <h3 className="m-b-16">Цена и остатки</h3>
            <p className="m-b-16">Если не указать цену и остатки, товар попадёт в "Сняты с продажи", вы сможете заполнить их позже
            </p>
            <table className="w-100">
              <thead>
                <tr>
                  <th>Точка продаж</th>
                  <th>Цена, тг</th>
                  <th>Остатки от 0 до 10000 шт</th>
                </tr>
              </thead>
              <tbody>
                {salePoints.data.map((salePoint, index) => {
                  return <tr key={salePoint.id}>
                    <td clasName="m-4">{salePoint.name} (г. {salePoint.city?.name})</td>
                    <td clasName="m-4">
                      <input type="hidden" {...methods.register(`salePoints[${index}][salePointID]`)} defaultValue={salePoint.id} />
                      <TextField
                        fullWidth
                        label="Цена, тг"
                        {...methods.register(`salePoints[${index}][price]`)}
                      />
                    </td>
                    <td>
                      <TextField
                        fullWidth
                        label="Остатки от 0 до 10000 шт"
                        {...methods.register(`salePoints[${index}][stock]`)}
                      />
                    </td>
                  </tr>
                })}
              </tbody>
            </table>
            <Button variant="contained" type="submit">{!id ? 'Отправить на модерацию' : 'Обновить товар'}</Button>
          </section>}
          <pre>
            {JSON.stringify(methods.watch(), null, 2)}
          </pre>
        </form>
      </FormProvider>
    </CrudPage >
  );
};
export default withRouter(
  withRemoteDataAndSpinner(ProductForm, (router) => {
    let requests = {
      categories: () => categoriesService.getAll(),
      vendors: () => vendorsService.getAll(),
      salePoints: () => warehousesService.getAll()
    }
    if (router.params.id) {
      requests['product'] = () => productsService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
